<template>
  <div
    :class="[
      'tw-w-full tw-flex tw-flex-col tw-relative tw-h-full',
      'tw-overflow-auto scrollbar-hide',
    ]"
  >
    <div
      :class="[
        'tw-text-h3-bold-mobile apTablet2:tw-text-h3-bold-desktop',
        'tw-mt-8 tw-mb-[64px]',
      // 'dark:tw-text-white'
      ]"
    >Describe your project in detail</div>
    <div class="tw-flex tw-flex-col tw-gap-[64px]">
      <TextAreaForm
        v-model:data="contactUs.project_description"
        :title="'<b>Provide a detailed description of your project so we can better assist you<b>'"
        :placeholder="`What is the problem your project is trying to solve?
Who are your target users?
Describe the features, product roadmap`"
      />
      <TextAreaForm
        v-model:data="contactUs.project_description2"
        :title="'<b>Products or services you would like to emulate</b> (optional)'"
        :placeholder="`What is the problem your project is trying to solve?
Who are your target users?
Describe the features, product roadmap`"
      />
      <div class="tw-grid tw-grid-cols-1 apDesktop:tw-grid-cols-2">
        <UploadFileForm v-model:file="contactUs.attachment_file" :title="'<b>Upload an attachment</b> (optional)'" placeholder="Upload PDF" />
      </div>
    </div>

    <vue-recaptcha
      ref="recaptchaRef"
      class="tw-pt-[64px]"
      :sitekey="sitekey"
      @verify="onVerify"
      @expired="onExpired"
    />

    <div class="apDesktop:tw-mb-[64px] tw-mb-[78px] tw-mt-[25px]">
      <NextButton label="Complete" :enable="allowNextButton" @click="emit('clickNext')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import VueRecaptcha from 'vue3-recaptcha2';
import { ContactUs } from '../../model/interfaces/ContactUs';
import { useTimer } from '../../support/helper';
import TextAreaForm from '../shared/TextAreaForm.vue';
import UploadFileForm from '../shared/UploadFileForm.vue';
import NextButton from './NextButton.vue';

const props = defineProps < {
  contactUs: ContactUs,
  isLoading: boolean
} > ();
const emit = defineEmits(['clickNext', 'recaptcha']);

const allowNextButton = computed(() => {
  return props.contactUs.isValidProjectDescription() && props.contactUs.isValidProjectDescription2() && recaptchaToken.value !== null && !props.isLoading;
});

const recaptchaTimer = useTimer(59, onExpired);
const recaptchaToken = ref<string | null>(null);
const recaptchaRef = ref(null);
const sitekey = ref(process.env.RECAPTCHA_V2_SITE_KEY);

function onVerify (token: string) {
  recaptchaToken.value = token;
  emit('recaptcha', token);
  recaptchaTimer.resetTimer();
  recaptchaTimer.startTimer();
}

function onExpired () {
  recaptchaToken.value = null;
}

</script>

<style scoped>
.scrollbar-hide::-webkit-scrollbar {
   display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
   -ms-overflow-style: none;  /* IE and Edge */
   scrollbar-width: none;  /* Firefox */
}
</style>